import { render, staticRenderFns } from "./veeError.vue?vue&type=template&id=f9b4df22"
import script from "./veeError.vue?vue&type=script&lang=js"
export * from "./veeError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports